<template>
  <div
    class="sales-analytics-conainer font-inter"
  >
    <!-- Filter section -->
    <sales-analytics-filter @filter-by-date="onFilterByDate" />

    <div
      v-if="isLoading"
      class="text-center p-5"
    >
      <b-spinner />
    </div>
    <div v-else-if="totalSelections">
      <!-- Sales Analytics list -->
      <sales-analytics-list :selections="selectionList" />
      <!-- pagination -->
      <b-row
        class="mt-2"
      >
        <b-col
          cols="12"
          class="d-flex align-items-center justify-content-center"
        >
          <b-pagination
            v-model="pageNumber"
            :total-rows="totalSelections"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0 page-link-class"
            prev-class="prev-item"
            next-class="next-item"
            @input="onApplyPagination"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <div
      v-else
      class="my-2"
    >
      <div class="empty-icon-bg bg-white mb-1 ">
        <feather-icon
          icon="SearchIcon"
          size="22"
        />
      </div>
      <b-card-text>
        <span>
          No selection has been shared.
        </span>
        <b-link
          class="click-here-link"
          @click="routeToShareSelection"
        >
          Click here
        </b-link>
        <span> to share your selection.</span>
      </b-card-text>
    </div>

  </div>

</template>

<script>
import {
 BCardText, BCol, BLink, BPagination, BRow, BSpinner,
} from 'bootstrap-vue'
import { useSalesAnalytics } from '@/composables/useSalesAnalytics'
import SalesAnalyticsFilter from './SalesAnalyticsFilter.vue'
import SalesAnalyticsList from './SalesAnalyticsList.vue'

export default {
    name: 'SalesAnalytics',
    components: {
        SalesAnalyticsList,
        SalesAnalyticsFilter,
        BSpinner,
        BCardText,
        BRow,
        BCol,
        BPagination,
        BLink,
    },
    setup() {
        const sa = useSalesAnalytics()
        sa.initSalesAnalytics()
        const { routeToShareSelection, ...rest } = sa
        return {
            ...rest,
            _routeToShareSelection: routeToShareSelection,
        }
    },
    methods: {
      routeToShareSelection() {
        this._routeToShareSelection(this.$router)
      },
    },
}
</script>

<style lang="scss">
.sales-analytics-conainer {
    .click-here-link {
        text-decoration: underline;
    }
}
</style>
